<template>
  <PageContent>
    <InputTitleSlug
    id="header-main-form"
      id-title="title"
      :is-loading="loading || disabled"
      :title="data.title"
      :title-error="validationErrors.title"
      :slug="data.slug"
      :slug-error="validationErrors.slug"
      :validationErrors="$options.validationRules"
      :isSlugEnabled="!isNew"
      @change:title="$emit('change:title', $event)"
      @change:slug="$emit('change:slug', $event)"
      @input:slug="$emit('input:slug', $event)"
    />
    <v-row>
      <v-col cols="12">
        <span>Тип бронирования*</span>
        <v-select
          id="bookingType"
          outlined
          no-data-text="Список пуст"
          item-value="value"
          item-text="title"
          :loading="loading"
          :disabled="disabled"
          :error-messages="validationErrors.bookingType"
          :items="$options.bookingTypes"
          :value="data.bookingType"
          @change="$emit('change:bookingType', $event)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <span>Подзаголовок (<TranslationIcon />)</span>
        <v-text-field
          outlined
          :loading="loading"
          :disabled="disabled"
          :value="data.subtitle"
          @change="$emit('change:subtitle', $event)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <MediaFilePicker
          id="thumbnailId"
          :label="'Миниатюра*'"
          :multiple="false"
          :file-type="$options.mediaTypesByKeys.IMAGE"
          :value="data.thumbnailId"
          @change="$emit('change:thumbnailId', $event)"
        />
        <ErrorMessage :message="validationErrors.thumbnailId" />
      </v-col>
      <v-col cols="12">
        <MediaFilePicker
          :label="'Изображения'"
          :file-type="$options.mediaTypesByKeys.IMAGE"
          :value="data.images"
          @change="$emit('change:images', $event)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <span>Цена*</span>
        <v-text-field
          id="price"
          outlined
          :loading="loading"
          :disabled="disabled"
          :error-messages="validationErrors.price"
          :value="data.price"
          @change="$emit('change:price', $event)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <span>Место проведения*</span>
        <LocationAutocomplete
          id="address"
          :address="data.address"
          :loading="loading || disabled"
          :error-messages="validationErrors.address[0]"
          @set-location="setLocation"
          @update-location-part="updateLocation"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" class="pb-0">
        <span id="description">Описание* (<TranslationIcon />)</span>
      </v-col>
      <QuillEditorVue
        :cols="12"
        :title="''"
        :isShowErrorMessage="true"
        :errorText="validationErrors.description"
        :content="data.description"
        :loading="loading"
        light-mode
        :disabled="disabled"
        @input="$emit('change:description', $event)"
        @onChangeContent="$emit('change:descriptionForMobile', $event)"
      />
    </v-row>
    <v-row>
      <v-col cols="6">
        <span>Возрастное ограничение*</span>
        <v-select
          id="ageRestriction"
          outlined
          :items="$options.ageList"
          :disabled="loading"
          :loading="loading"
          :error-messages="validationErrors.ageRestriction"
          :value="data.ageRestriction"
          @change="$emit('change:ageRestriction', $event)"
        />
      </v-col>
    </v-row>
    <v-row
      v-for="(attributeField, attributeFieldIndex) in category.attributeKeys"
      :key="attributeFieldIndex"
    >
      <v-col cols="6">
        <component
          :is="`attribute-field-${attributeField.type}`"
          :attribute-data="attributeField"
          :is-loading="loading || disabled"
          :value="getAttributeValue(attributeField)"
          :error-message="getAttributeErrorMessage(attributeField)"
          @input="updateAttributeValue($event, attributeField)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <SeoSettings
          :data="seoData"
          :loading="loading || disabled"
          @on-input-seo="$emit('on-input-seo', $event)"
        />
      </v-col>
    </v-row>
  </PageContent>
</template>

<script>
import { mediaTypesByKeys } from '@/configs/mediaFileTypes'
import ageList from '@/configs/ageList'

import validationRules from '@/pages/event/form/validationRules.js'

import LocationAutocomplete from '@/components/location-autocomplete'
// import ManageSidePanel from '@/components/manage-side-panel'
import MediaFilePicker from '@/components/media-file-picker'
import SeoSettings from '@/components/seo-settings'
import TranslationIcon from '@/components/translation-icon/translationIcon'
import InputTitleSlug from '@/components/inputs/InputTitleSlug'
import QuillEditorVue from '@/components/quill-editor'
import ErrorMessage from '@/components/error-messages'

import attributeFieldSTRING from '@/components/attribute-form-fields/attribute-field-STRING.vue'
import attributeFieldNUMERIC from '@/components/attribute-form-fields/attribute-field-NUMERIC.vue'
import attributeFieldDATETIME from '@/components/attribute-form-fields/attribute-field-DATETIME.vue'
import attributeFieldBOOLEAN from '@/components/attribute-form-fields/attribute-field-BOOLEAN.vue'
import attributeFieldFILE from '@/components/attribute-form-fields/attribute-field-FILE.vue'
import PageContent from '@/components/page-content/PageContent.vue'

const bookingTypes = [
  {
    value: 'REGULAR',
    title: 'Стандартное бронирование'
  },
  {
    value: 'EXTERNAL',
    title: 'Внешнее бронирование (URL)'
  },
  {
    value: 'NONE',
    title: 'Без бронирования'
  }
]
export default {
  name: 'FormEventMain',
  bookingTypes,
  validationRules,
  mediaTypesByKeys: mediaTypesByKeys(),
  ageList,
  props: {
    category: {
      type: Object,
      default: null
    },
    validationErrors: {
      type: Object,
      default: () => ({})
    },
    eventAttributes: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: true
    },
    data: {
      type: Object,
      default: null
    },
    isNew: {
      type: Boolean,
      default: true
    }
  },
  components: {
    PageContent,
    InputTitleSlug,
    TranslationIcon,
    // ManageSidePanel,
    attributeFieldSTRING,
    attributeFieldNUMERIC,
    attributeFieldDATETIME,
    attributeFieldBOOLEAN,
    attributeFieldFILE,
    LocationAutocomplete,
    MediaFilePicker,
    SeoSettings,
    QuillEditorVue,
    ErrorMessage
  },
  computed: {
    seoData () {
      return {
        seoMetaTitle: this.data?.seoMetaTitle || null,
        seoMetaDescription: this.data?.seoMetaDescription || null,
        seoDisallowIndex: this.data?.seoDisallowIndex || false,
        seoMetaKeywords: this.data?.seoMetaKeywords || null,
        seoRelCanonical: this.data?.seoRelCanonical || null,
        seoOgimages: this.data?.seoOgimages || null
      }
    }
  },
  watch: {
    loading (newVal) {
      if (!newVal) {
        document.querySelector('#header-main-form').scrollIntoView({ block: 'center', behavior: 'smooth' })
      }
    }
  },
  methods: {
    getAttributeValue ({ name }) {
      const value = this.eventAttributes[name]?.value
      if (value && value.id !== undefined) return value.id
      return value
    },
    getAttributeErrorMessage ({ name }) {
      if (this.validationErrors.attributes !== undefined) {
        return this.validationErrors.attributes[name]
      } else return ''
    },
    updateAttributeValue (newVal, { name, type }) {
      let value = newVal
      if (newVal && newVal.id !== undefined) value = newVal.id
      this.$emit('update-attribute-value', { value, type, name })
    },
    setLocation (location) {
      this.$emit('set-location', location)
    },
    updateLocation ({ value, fieldName }) {
      this.$emit('update-location', { value, fieldName })
    }
  }
}
</script>
